import { BehaviorEnum, Properties } from "@/services/posts/types";
import { Position } from "./image";
import { CSS } from "@/services/styles/types";

export interface FixedHtmlProperties extends Properties {
    showTime: number;
    contentTemplateId: string;
    contentTemplate: string;
    data: fixedHtmlData[];
}

export interface ComponentData {
    data: fixedHtmlData[];
}

export interface fixedHtmlData {
    [key: string]: any;
    id: string;
    text: string;
    src: string;
    toolbar: string;
    preventOverflow: string;
    adjustOnly: string;
    behavior: BehaviorEnum;
    position: Position;
    fontSizes: string;
    qrCodeValue: string;
    qrCodeSize: string;
    qrCodeQuiteZone: string;
    macros: Macros;
}

export interface Macros {
    type: MacrosTypeEnum;
    countIn: MacrosCountInEnum;
    date: string;
    time: string;
    macrosOptions: MacrosOptions;
}

export interface MacrosOptions {
    type: boolean;
    countIn: boolean;
}

export enum MacrosTypeEnum {
    countUp = "countup",
    countDown = "countdown"
}

export enum MacrosCountInEnum {
    days = "days",
    daysWithTime = "dayswithtime"
}

export interface fileUploadStages {
    fileIsUploading: boolean;
    imageId: string;
    failedUploading: boolean;
}

export interface fixedHtmlCSS extends CSS {
    wrapper: string,
}
